import { useEffect, useState } from 'react';
import { BiCheck, BiX } from 'react-icons/bi';

import { WrappedErrorBoundary } from '../WrappedErrorBoundary';

const PassWordValidationChecker = ({ password, ruleSet }: { password: string; ruleSet: Array<any>[] }) => {
  const [rules, setRules] = useState<Array<any>>([]);

  useEffect(() => {
    const cloneArr = [
      ...ruleSet.map((item: any) => {
        return { ...item, regex: new RegExp(item.regex) };
      }),
    ];

    cloneArr.forEach(rule => {
      if (rule.regex.test(password)) rule.isPassed = true;
      else rule.isPassed = false;
    });

    setRules(cloneArr);
  }, [password]);

  return (
    <div className="password-validator">
      <ul className="list-unstyled">
        {rules.map(rule => (
          <li key={rule.text} className={`${!rule.isPassed ? 'text-danger' : 'text-success'}`}>
            {!rule.isPassed ? <BiX size={22} /> : <BiCheck size={22} />}
            <span className="ms-2"> {rule.textTranslated}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WrappedErrorBoundary(PassWordValidationChecker);
